export default `float s=2., e;
    for(int j=0;j++<8;)
      s*=e=2./clamp(dot(p,p),.2,1.),
      p=abs(p)*e-vec3(.5,8.0,.5);
    return length(cross(p,vec3(1.0,1.0,-1.0)))/s;
  }`